import { useState } from 'react';
import { 
  LeftNavigationItem, 
  LeftNavigationItemContent, 
  LeftNavigationItemMenu, 
  LeftNavigationItemButton } from '@tag/tag-components-react-v4';

import { MenuItem } from '@/config/navigation.config';
import { UserRole } from '@/config/roles.config';
import { getParameterizedLink, getFullWorkspaceLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { browserHistory } from '@/routing/browserHistory';

export interface NavItemProps {
  item: MenuItem;
  userRole: UserRole | undefined;
  selectedNavItem?: string;
}

export function NavItem({ item, userRole, selectedNavItem }: NavItemProps) {
  const [collapsedMenuItems, setCollpasedMenuItems] = useState(false);

  if (!userRole) {
    return null;
  }

  if (item.children?.length && item.accessLevel.includes(userRole)) {
    return (
      <LeftNavigationItemMenu
        text={item.text}
        icon={<item.icon />}
        collapsed={collapsedMenuItems}
        onCollapsedChange={() => setCollpasedMenuItems((collapsed) => !collapsed)}
      >
        {item.children?.map((childItem) => (
          <div key={childItem.text}>
            <NavItem item={childItem} userRole={userRole} selectedNavItem={selectedNavItem} />
          </div>
        ))}
      </LeftNavigationItemMenu>
    );
  }

  const handleNavLinkClick = (e: React.MouseEvent, link: string) => {
    if ((e.ctrlKey || e.metaKey) && e.button === 0) {
      e.stopPropagation();
      return;
    }
    if (e.button === 0) {
      e.preventDefault();
      browserHistory.push(getParameterizedLink(link));
    }
  };

  if (item.accessLevel.includes(userRole)) {
    const isSelected = selectedNavItem === item.link;

    return (
      <LeftNavigationItem name={item.link!}>
        <a
          href={getFullWorkspaceLink(getParameterizedLink(item.link!))}
          onClick={(e) => handleNavLinkClick(e, item.link!)}
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'block',
            width: '100%',
            height: '100%',
            outline: 'none'
          }}

          className={isSelected ? 'nav-item-selected' : undefined}
        >
          <LeftNavigationItemButton>
            <LeftNavigationItemContent icon={<item.icon />} text={item.text} indent={item.indent} />
          </LeftNavigationItemButton>
        </a>
      </LeftNavigationItem>
    );
  }

  return null;
}
